import getManagePathPrefix from "../tools/getManagePathPrefix";
import { wujiRequest } from "../core/common/wujiRequest";
import { isOffline } from "../tools/offline";
export class CollectionLogService {
  async createLogs(logs, options) {
    // 如果是离线环境，则不上报日志
    if (isOffline()) return;
    try {
      const {
        collectionId,
        projectId,
        cgiId
      } = options;
      const url = `${getManagePathPrefix({
        isRuntimeRoute: true
      })}/datasource/collection/log/${projectId}/${collectionId}/${cgiId}`;
      const res = await wujiRequest({
        url,
        method: 'post',
        data: logs
      });
      return res;
    } catch (error) {
      // 日志上报有有问题不影响主流程
      console.error(error);
      return null;
    }
  }
}
export const collectionLogService = new CollectionLogService();
//# sourceMappingURL=collectionLogService.js.map
